import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import PlatformMockup from "./PlatformMockup";

export default function Hero() {
  const { t, path } = useI18n();

  return (
    <section className="relative pt-28 pb-16 lg:pt-32 lg:pb-20 flex items-center">
      <div className="mx-auto max-w-container px-6 lg:px-10 w-full">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-12 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-6">
              {t.home.heroEyebrow}
            </div>
            <h1 className="font-serif text-[44px] sm:text-[56px] lg:text-[68px] leading-[1.05] tracking-tight">
              {t.home.heroLine1} <br />
              {t.home.heroLine2} <br />
              <span className="italic text-primary">{t.home.heroAccent}</span>
            </h1>
            <p className="mt-8 text-lg text-muted-foreground leading-relaxed max-w-prose">
              {t.home.heroBody}
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-6">
              <Link
                to={path("contact")}
                className="inline-flex items-center rounded-md bg-primary px-6 py-3.5 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
              >
                {t.nav.demo}
              </Link>
              <Link
                to={path("how")}
                className="text-sm text-foreground underline underline-offset-[6px] decoration-border hover:decoration-foreground transition-colors"
              >
                {t.home.heroSecondary}
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6 reveal" style={{ transitionDelay: "120ms" }}>
            <PlatformMockup />
          </div>
        </div>
      </div>
    </section>
  );
}
